import { Box, Typography, Container, Switch } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useBrandContext } from "../App";
import { brands } from "../data";

export const Header = () => {
  const { lang } = useParams();
  const { brand } = useBrandContext();
  const navigate = useNavigate();

  const handleLangChange = currentLang => {
    const currentPath = window.location.pathname.split("/").slice(2);
    navigate(`/${currentLang}/${currentPath.join("/")}`);
  };

  return (
    <Box
      sx={{
        backgroundColor: "primary.main",
        color: "primary.contrastText",
      }}
    >
      <Container maxWidth="lg" component="header">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          height={75}
        >
          <Box
            component="img"
            src={brands[brand].logo}
            alt="logo"
            height={41}
            ml={-3}
          />
          <Box display="flex" gap={1} alignItems="center">
            <LangItem lang="EN" icon={`${process.env.REACT_APP_AZURE_STORAGE}/en.svg`} onClick />
            <Switch
              inputProps={{ "aria-label": "Switch languaje" }}
              defaultChecked
              onChange={() => handleLangChange(lang === "en" ? "fr" : "en")}
              checked={lang === "fr"}
            />
            <LangItem lang="FR" icon={`${process.env.REACT_APP_AZURE_STORAGE}/fr.svg`} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

const LangItem = ({ lang, icon }) => {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography variant="bold" fontSize={14}>
        {lang}
      </Typography>
      <Box component="img" src={icon} alt={lang} height={14} mb={0.1} />
    </Box>
  );
};
